export const customChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

export type EncodedValue = string;
export type DecodedValue = number | bigint | string | Array<any> | { [key: string]: any } | boolean;
